import { createModuleBuilder } from '@evidentid/dashboard-commons/app';
import { GatewayApiClient } from '@evidentid/gateway-api-client';
import Logger from '@evidentid/logger';
import Tracker from '@evidentid/tracker';

import CustomPropertiesManagementView from '@/modules/dashboard-configuration/views/CustomPropertiesManagementView.vue';

export const dashboardConfigurationModule = createModuleBuilder()
    .registerRoutes(() => [
        {
            path: '/:rpId?/configuration/custom-properties',
            name: 'customProperties',
            component: CustomPropertiesManagementView as any,
            meta: { title: 'Custom Properties', pageClass: 'CustomPropertiesManagement' },
        },
    ]).demandContext<{
    gatewayClient: GatewayApiClient;
    tracker?: Tracker<any>;
    logger?: Logger<any>;
}>()
    .end();
